import React from 'react';
import { translations } from '../data/translations';
import { Button } from "./ui/button";
import { Download } from 'lucide-react';

export const RestaurantMenu = ({ lang }) => {
  const t = translations[lang].menu;

  return (
    <section id="menu" className="py-24 bg-zinc-900 text-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12 space-y-4">
          <span className="text-red-500 font-bold uppercase tracking-widest text-sm">{t.subtitle}</span>
          <h2 className="text-4xl md:text-5xl font-bold">{t.title}</h2>
          <div className="w-24 h-1 bg-red-600 mx-auto rounded-full"></div>
        </div>

        <div className="max-w-xl mx-auto bg-zinc-950/50 p-12 rounded-2xl border border-zinc-800 shadow-xl text-center">
           <p className="text-gray-400 mb-8 text-lg">
             {lang === 'fi' ? 'Tutustu herkulliseen ruokalistaamme lataamalla PDF-menu.' : 
              lang === 'sv' ? 'Utforska vår läckra meny genom att ladda ner PDF-menyn.' :
              'Explore our delicious offerings by downloading our PDF menu.'}
           </p>
           <Button 
             variant="outline" 
             size="lg"
             className="gap-3 border-red-600 text-red-500 hover:bg-red-600 hover:text-white transition-all uppercase tracking-wider h-14 text-lg px-8"
             onClick={() => window.open('/menu.pdf', '_blank')}
           >
             <Download className="w-5 h-5" />
             {t.download_pdf}
           </Button>
        </div>
      </div>
    </section>
  );
};
